export const ACTIVITY_VIEW  = { id: 'ACTIVITY_VIEW', text: 'Activity' };
export const BED_VIEW       = { id: 'BED_VIEW', text: 'Monitor' };